module.exports = __webpack_public_path__ + "static/media/bunu01.6105f652.gif";